import { useCreateOrEditPricingPolicyMutation, useListPricingPolicies, useRemovePricingPolicyMutation } from "@/queries/pricing-policy.queries";
import uuidService from "@/services/uuid.service";
import { t } from "i18next";

export function usePricingPolicyList() {
    const query = useListPricingPolicies();
    const createOrEditPricingPolicyMutation = useCreateOrEditPricingPolicyMutation();
    const removePricingPolicyMutation = useRemovePricingPolicyMutation();

    function handleCreatePolicyClick() {
        return createOrEditPricingPolicyMutation.mutateAsync({
            policy: {
                id: uuidService.v4(),
                currency: 'EUR',
                name: t('new price policy'),
                overrides: [],
                priceSpecification: {
                    type: 'FixedPriceSpecification',
                    amount: '50.0',
                },
                tags: {

                }
            }
        })
    }

    function handleRemovePricingPolicyClick(id: string) {
        return removePricingPolicyMutation.mutateAsync({ id })
    }

    return {
        query,
        handleCreatePolicyClick,
        handleRemovePricingPolicyClick,
    }
}